import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Styles from '../../Style/Common.module.css';
import BtnStyle from '../../Style/Button.module.css';
import { Link, useLocation } from "react-router-dom";
import { getServicesTypeDetailAPI, 
        getXLSDownloadAPI, 
        getKeyAspectsAPI, 
        getCFTschemesAPI, 
        getWhyChooseusAPI, 
        getprocessServicesAPI, 
        getDelivirableServicesAPI } from '../../../services/routes.services';
import parse from 'html-react-parser';
import constants from '../../../services/constants';
import Loader from "../../Common/PageLoader/LoadingSpinner";
import { IoCloseSharp } from "react-icons/io5";
import Breadcrumb from "./BreadCrumb";
import { useSelector } from 'react-redux';
import MenuPath from "../../Common/Header/CurrentPath";
import axios from 'axios';
import $ from 'jquery';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CustomButtonGroup from "../../Common/CustomButtonGroup";
//icon
import { RxArrowTopRight } from "react-icons/rx"

const useCarouselBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState("desktop");
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width < 580) {
                setBreakpoint("mobile");
            } else if (width < 1024) {
                setBreakpoint("tablet");
            } else {
                setBreakpoint("desktop");
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return breakpoint;
};
const getCarouselPlay = (
    length,
    breakpoint,
    desktopItems = 3,
    tabletItems = 2
) => {
    if (!length) {
        return false;
    }
    // Mobile shows only 1 item
    if (breakpoint === "mobile") {
        return length > 1;
    }
    // Tablet
    if (breakpoint === "tablet") {
        return length > tabletItems;
    }
    // Desktop
    return length > desktopItems;
};
const shouldShowCarouselButtons = (
    length,
    breakpoint,
    desktopItems = 3,
    tabletItems = 2
    ) => {
    if (!length) return false;

    if (breakpoint === "mobile") {
        return length > 1;
    }
    if (breakpoint === "tablet") {
        return length > tabletItems;
    }
    return length > desktopItems;
};

const CertificationDetail = ()=>{ 
    //math Path
    const location = useLocation();
    const { menu } = useSelector(state => state.header);
    const currentPageUrl = location.pathname;
    const serviceUrl = currentPageUrl.replace(/^\/+/, "");
    const currentMenuItem = MenuPath(menu, currentPageUrl);
    const BannerImage = currentMenuItem ? currentMenuItem.image : ''; 
    const BannerTitle = currentMenuItem ? currentMenuItem.linkText : ''; 

    const [indgapData, setIndgapData] = useState([]);
    const [vcsmppData, setVcsmppData] = useState([]);
    const [uasData, setUasData] = useState([])
    const [loading, setLoading] = useState(false);
    const breakpoint = useCarouselBreakpoint();
    
    // new Data
    const [organicData, setOrganicData] = useState([]);
    const [whoForData, setWhoForData] = useState([]);
    const [schemesData, setSchemesData] = useState([]);
    const [processData, setProcessData] = useState([]);
    const [benefitsData, setBenefitsData] = useState([]);
    const [delivirableData, setDelivirableData] = useState([]);

    //Breakpoint
    const whyTQSlide = {
        superLargeDesktop: {breakpoint: { max: 4000, min: 3000 },items: 3},
        desktop: {breakpoint: { max: 3000, min: 1024 },items: 3},
        tablet: {breakpoint: { max: 1024, min: 580 },items: 2},
        mobile: {breakpoint: { max: 580, min: 0 },items: 1}
    };

    const schemesSlide = {
        superLargeDesktop: {breakpoint: { max: 4000, min: 3000 },items: 3,},
        desktop: {breakpoint: { max: 3000, min: 1024 },items: 3},
        tablet: {breakpoint: { max: 1024, min: 580 },items: 2},
        mobile: {breakpoint: { max: 580, min: 0 },items: 1}
    };

    const deliverablesSlide = {
        superLargeDesktop: {breakpoint: { max: 4000, min: 3000 },items: 2,},
        desktop: {breakpoint: { max: 3000, min: 1024 },items: 2},
        tablet: {breakpoint: { max: 1024, min: 767 },items: 2},
        mobile: {breakpoint: { max: 767, min: 0 },items: 1}
    };

    
    //Data length
    const schemesLength = schemesData?.fields?.length || 0;
    const benefitsLength = benefitsData?.fields?.length || 0;
    const deliverablesLength = delivirableData?.fields?.length || 0;
    
    //Autoplay / Infinite
    
    //Certifications
    const schemesAutoPlay = getCarouselPlay(schemesLength, breakpoint, 3, 2);
    //Benefits
    const benefitsAutoPlay = getCarouselPlay(benefitsLength, breakpoint, 3, 2);
    const benefitsShowButtons = shouldShowCarouselButtons(benefitsLength, breakpoint, 3, 2);
    //Deliverables
    const deliverablesAutoPlay = getCarouselPlay(deliverablesLength, breakpoint, 2, 2);
    
    //Carousel center class
    const carouselClass = schemesLength === 1 ? "centerOneCarousel" : schemesLength === 2 ? "centerTwoCarousel" : "";
    const deliverCarouselClass =  deliverablesLength === 1 ? "centerCarousel" : "";
    console.log(serviceUrl)
    useEffect(()=>{
        if (!serviceUrl) return;
        setLoading(true)
        Promise.all([
            getServicesTypeDetailAPI(serviceUrl),
            getKeyAspectsAPI(serviceUrl),
            getCFTschemesAPI(serviceUrl),
            getprocessServicesAPI(serviceUrl),
            getWhyChooseusAPI(serviceUrl),
            getDelivirableServicesAPI(serviceUrl),
        ]).then(([orgRes, whoForRes, schemesRes, processRes, benefitsRes, delivirableRes])=>{
            setOrganicData(orgRes.data.servicedetails[0]?.fields[0]);
            setWhoForData(whoForRes?.data?.iconservice[0]);
            setSchemesData(schemesRes?.data?.servicedetails[0]);
            setProcessData(processRes?.data?.processservice[0]);
            setBenefitsData(benefitsRes?.data?.whychooseus[0]);
            setDelivirableData(delivirableRes?.data?.delivirable[0]);
        }).catch(error =>{ 
            console.log(error)
        }).finally(()=>{
            setLoading(false)
        });
    }, [])
    console.log(organicData)
    // useEffect(()=>{
    //     setLoading(true)
    //     Promise.all([
    //         getServicesTypeDetailAPI('organic-certification'),
    //         getXLSDownloadAPI('INDGAP'),
    //         getXLSDownloadAPI('VCSMPP'),
    //         getXLSDownloadAPI('UAS')
    //     ]).then(([orgRes, indgapRes, vcsmppRes, uasRes])=>{
    //         setOrganicData(orgRes.data.servicedetails[0]);
    //         setIndgapData(indgapRes.data.customers);
    //         setVcsmppData(vcsmppRes.data.customers);
    //         setUasData(uasRes.data.customers)
    //     }).catch(error =>{ 
    //         console.log(error)
    //     }).finally(()=>{
    //         setLoading(false)
    //     });
    // }, [])
    if (loading) {
        return <Loader />;
    }
    const downloadXLSFile = async (image, name) => {
        // try {
        //     const response = await axios.get(image, {
        //         responseType: 'blob',
        //     });
        //     const blob = new Blob([response.data], {
        //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //     });
        //     const link = document.createElement('a');
        //     link.href = window.URL.createObjectURL(blob);
        //     document.body.appendChild(link);
        //     link.download = name;
        //     link.click();
        //     link.parentNode.removeChild(link);
        // } catch (error) {
        //     console.error('Error downloading the file', error);
        // }
        const link = document.createElement('a');
    link.href = image; // Use the direct image link
    link.target = '_blank'; // Open in a new tab
    link.download = name; // Specify the download name
    document.body.appendChild(link);
    link.click(); // Programmatically click the link
    link.remove(); // Remove the link from the DOM
    };
    const handleClickMenu = (e) => {
        $('.mobMenuInner').toggleClass('active-class');
      };
    const handleScroll = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return(
        <div className={'CertificationPage ' + Styles.OrganicPage }>
             <>
                <div className={Styles.innerBanner + ' ' + Styles.InnerSmallBanner}>
                    {BannerImage && <img src={constants.Image_BASE_URL+""+BannerImage} className={Styles.innerBannerimg} />}
                    <div className={Styles.innerBannerContent}>
                        <Container>
                            <Row>
                                <Col>
                                    <div className={Styles.detail}>
                                        <h2 className={serviceUrl === "qms-iso-certification" ? Styles.cfTitle : ""}>{BannerTitle}</h2>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
                <Breadcrumb />
                {organicData && 
                    <div className={Styles.orgSection}>
                        <Container fluid className={Styles.orgContainer}>
                            <Row>
                                <Col md={5}>
                                    <div className={Styles.orgImg}>
                                        <figure>
                                            <img src={`${constants.Image_BASE_URL}${organicData?.image?.[0]?.fileName}`} alt={organicData?.title    } />
                                        </figure>
                                    </div>
                                </Col>
                                <Col md={7}>
                                    <div className={Styles.orgContent}>
                                        <h2>{organicData?.title}</h2>
                                        {organicData?.description && parse(String(organicData.description))}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                }
                {whoForData && whoForData?.fields?.length > 0 && (
                    <div className={Styles.whoSection}>
                        <Container>
                            <Row>
                                <Col>
                                    <div className={Styles.whoElement}>
                                        <h2>{whoForData?.heading || "Who It’s For"}</h2>
                                        <ul>
                                            {whoForData?.fields?.map((item, index)=>(
                                                <li key={index}>
                                                    <figure>
                                                        <img src={`${constants.Image_BASE_URL}${item?.icon}`} />
                                                    </figure>
                                                    <p>{item?.title}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )}
                {schemesData && schemesData?.fields?.length > 0 && (
                    <div className={Styles.schemeSec}>
                        <Container fluid className={Styles.orgContainer}>
                            <Row>
                                <Col>
                                    <div className={Styles.schemeElement}>
                                        <h2>{schemesData?.heading || "Certification Schemes"}</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Carousel
                                        autoPlaySpeed={3000}
                                        transitionDuration={500}
                                        responsive={schemesSlide}
                                        autoPlay={schemesAutoPlay}
                                        infinite={schemesAutoPlay}
                                        arrows={false}
                                        containerClass={carouselClass}
                                    >
                                    {schemesData?.fields?.map((item, index)=>(
                                            <div className={Styles.item} key={index}>
                                                <div className={Styles.box}>
                                                    <figure>
                                                        <img src={`${constants.Image_BASE_URL}${item?.image[0]?.fileName}`} />
                                                    </figure>
                                                    <div className={Styles.schemeContent}>
                                                        <p>{item?.title}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}  
                                    </Carousel>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )}
                {processData && processData?.fields?.length > 0 && (
                    <div className={Styles.processSec}>
                        <Container className={Styles.orgContainer}>
                            <Row>
                                <Col>
                                    <div className={Styles.processElem}>
                                        <div className={Styles.content}>
                                            <h2>{processData?.heading || "Process"}</h2>
                                            <ul>
                                                {processData?.fields?.map((item, index) => (
                                                    <li key={index}>
                                                        <figure>
                                                            <img src={`${constants.Image_BASE_URL}${item?.icon}`} alt={item?.title}/>
                                                        </figure>
                                                        <p>{item?.title}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className={Styles.processimg}>
                                            <img src={`${constants.Image_BASE_URL}${processData?.image}`} />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )}
                {benefitsData && benefitsData?.fields?.length > 0 && (
                    <div className={'valuesSection ' + Styles.valueSec + " " + Styles.whuchooseSec + " " + Styles.owlStyle}>
                        <Container fluid>
                        <Row>
                            <Col>
                            <div className={Styles.valuesContainer}>
                                <h2>{benefitsData?.heading || "Benefits"}</h2>
                                <div className={'navBtn ' + Styles.valueOwl + " " + Styles.cftFlex}>
                                    <Carousel
                                        autoPlaySpeed={3000}
                                        transitionDuration={500}
                                        responsive={whyTQSlide}
                                        autoPlay={benefitsAutoPlay}
                                        infinite={benefitsAutoPlay}
                                        arrows={false}
                                        customButtonGroup={benefitsShowButtons ? <CustomButtonGroup /> : null}
                                        renderButtonGroupOutside={benefitsShowButtons}
                                        containerClass={benefitsLength <= 2 ? "whyUsOwl whyUsOwlCenter" : "whyUsOwl"}
                                    >
                                    {benefitsData?.fields?.length > 0 && benefitsData?.fields?.map((item, index)=>{
                                        return(
                                            <div className={Styles.valueSlide} key={index}>
                                                <figure>
                                                    <img src={constants.Image_BASE_URL+""+item.image[0].fileName} />
                                                </figure>
                                                <p>{item?.title}</p>
                                            </div>
                                        )
                                    })}

                                </Carousel>
                                </div>
                            </div>
                            </Col>
                        </Row>
                        </Container>
                    </div>
                )}
                {delivirableData && delivirableData?.fields?.length > 0 &&
                    <div className={Styles.deliverablesSec}>
                        <Container>
                            <Row>
                                <Col>
                                    <h2>{delivirableData?.heading || "Deliverables"}</h2>
                                    <div className={Styles.deliverablesOwl}>
                                        <Carousel
                                            autoPlaySpeed={3000}
                                            transitionDuration={500}
                                            responsive={deliverablesSlide}
                                            autoPlay={deliverablesAutoPlay}
                                            infinite={deliverablesAutoPlay}
                                            arrows={false}
                                            containerClass={deliverCarouselClass}
                                        >
                                            {delivirableData?.fields?.map((item, index)=>(
                                                <div className={Styles.box} key={index}>
                                                    <figure>
                                                        <img src={`${constants.Image_BASE_URL}${item?.icon}`} />
                                                    </figure>
                                                    <h4>{item?.title}</h4>
                                                </div>
                                            ))}
                                        </Carousel> 
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                }
                {delivirableData && delivirableData?.links?.length > 0 &&
                    <div className={Styles.servicesBtnSec}>
                        <Container>
                            <Row>
                                <Col>
                                    <div className={Styles.servicesBtn}>
                                        {delivirableData?.links?.map((item, index)=>(
                                            <Link key={index} to={item?.link}>{item?.name} <span className={Styles.icon}><RxArrowTopRight /></span></Link>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>               
                }
            </>

        </div>
    )
}
export default CertificationDetail;